/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: inline-block;
}

:host([width=auto]) {
  inline-size: auto;
}

:host([width=half]) {
  inline-size: 50%;
}

:host([width=full]) {
  inline-size: 100%;
}

:host([kind=brand]) {
  --calcite-internal-split-button-background: var(--calcite-color-brand);
  --calcite-internal-split-button-divider: var(--calcite-color-foreground-1);
}

:host([kind=danger]) {
  --calcite-internal-split-button-background: var(--calcite-color-status-danger);
  --calcite-internal-split-button-divider: var(--calcite-color-foreground-1);
}

:host([kind=neutral]) {
  --calcite-internal-split-button-background: var(--calcite-color-foreground-3);
  --calcite-internal-split-button-divider: var(--calcite-color-text-1);
}

:host([kind=inverse]) {
  --calcite-internal-split-button-background: var(--calcite-color-inverse);
  --calcite-internal-split-button-divider: var(--calcite-color-foreground-1);
}

:host([appearance=transparent]) {
  --calcite-internal-split-button-background: transparent;
}
:host([appearance=transparent]):host([kind=brand]) {
  --calcite-internal-split-button-divider: var(--calcite-color-brand);
}
:host([appearance=transparent]):host([kind=danger]) {
  --calcite-internal-split-button-divider: var(--calcite-color-status-danger);
}
:host([appearance=transparent]):host([kind=neutral]) {
  --calcite-internal-split-button-divider: var(--calcite-color-text-1);
}
:host([appearance=transparent]):host([kind=inverse]) {
  --calcite-internal-split-button-divider: var(--calcite-color-foreground-1);
}

:host([appearance=outline]):host([kind=brand]), :host([appearance=outline]):host([kind=danger]), :host([appearance=outline]):host([kind=neutral]), :host([appearance=outline]):host([kind=inverse]) {
  --calcite-internal-split-button-background: transparent;
}

:host([appearance=outline-fill]):host([kind=brand]), :host([appearance=outline-fill]):host([kind=danger]), :host([appearance=outline-fill]):host([kind=neutral]), :host([appearance=outline-fill]):host([kind=inverse]) {
  --calcite-internal-split-button-background: var(--calcite-color-background);
}

:host([appearance=outline]):host([kind=brand]),
:host([appearance=outline-fill]):host([kind=brand]) {
  --calcite-internal-split-button-divider: var(--calcite-color-brand);
}
:host([appearance=outline]):host([kind=danger]),
:host([appearance=outline-fill]):host([kind=danger]) {
  --calcite-internal-split-button-divider: var(--calcite-color-status-danger);
}
:host([appearance=outline]):host([kind=neutral]),
:host([appearance=outline-fill]):host([kind=neutral]) {
  --calcite-internal-split-button-divider: var(--calcite-color-border-1);
}
:host([appearance=outline]):host([kind=inverse]),
:host([appearance=outline-fill]):host([kind=inverse]) {
  --calcite-internal-split-button-divider: var(--calcite-color-inverse);
}

.container {
  display: flex;
  align-items: stretch;
}
.container > calcite-dropdown > calcite-button {
  block-size: 100%;
  vertical-align: top;
}

.divider-container {
  display: flex;
  inline-size: 1px;
  align-items: stretch;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  background-color: var(--calcite-internal-split-button-background);
}

.divider {
  margin-block: 0.25rem;
  display: inline-block;
  inline-size: 1px;
  background-color: var(--calcite-internal-split-button-divider);
}

:host([appearance=outline-fill]) .divider-container,
:host([appearance=outline]) .divider-container {
  border-block: 1px solid var(--calcite-internal-split-button-divider);
}
:host([appearance=outline-fill]):hover .divider-container,
:host([appearance=outline]):hover .divider-container {
  background-color: var(--calcite-internal-split-button-divider);
}

:host([appearance=outline-fill]:hover) .divider-container,
:host([appearance=outline]:hover) .divider-container {
  background-color: var(--calcite-internal-split-button-divider);
}

:host([appearance=outline-fill]:focus-within):host([kind=brand]),
:host([appearance=outline]:focus-within):host([kind=brand]) {
  --calcite-internal-split-button-divider: var(--calcite-color-brand-press);
}
:host([appearance=outline-fill]:focus-within):host([kind=danger]),
:host([appearance=outline]:focus-within):host([kind=danger]) {
  --calcite-internal-split-button-divider: var(--calcite-color-status-danger-press);
}
:host([appearance=outline-fill]:focus-within) .divider-container,
:host([appearance=outline]:focus-within) .divider-container {
  background-color: var(--calcite-internal-split-button-divider);
}

:host([disabled]) calcite-dropdown > calcite-button {
  pointer-events: none;
}
:host([disabled]):host([appearance=outline-fill]) .divider-container {
  background-color: var(--calcite-color-background);
}
:host([disabled]):host([appearance=outline]) .divider-container {
  background-color: transparent;
}
:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}